import { useEffect, useState } from "react";

/** Single source of truth for the «عاجل» badge.
 *  Rule (2026-09, replaces classification by section/title): the badge belongs to
 *  the NEWEST successfully published article site-wide — by original
 *  `published_at`, then `id` as a stable tiebreak. Editing an old article, saving a
 *  draft or a re-received Telegram message never moves it (published_at unchanged /
 *  not visible). Scheduled items count only once they are actually visible.
 *  Candidates come from the live poller (scope=all, newest window), the home
 *  payload and the article page; the store only moves forward in time, and pages
 *  that do not contain the newest article show no badge at all. */
export const newerThan = (a, b) => !b || String(a.published_at || "") > String(b.published_at || "") || (a.published_at === b.published_at && String(a.id) > String(b.id));

const state = { active: null, listeners: new Set() };
const emit = () => state.listeners.forEach((fn) => fn(state.active));

export function considerBreaking(list) {
    let best = state.active;
    for (const a of list || []) if (a?.id && a.published_at && newerThan(a, best)) best = a;
    if (best && best !== state.active) { state.active = { id: best.id, published_at: best.published_at }; emit(); }
}
/** Authoritative window from the poller: newest visible article wins even if the
 *  previous holder was withdrawn. */
export function syncBreakingFromWindow(items) {
    const best = (items || []).filter((a) => a?.id && a.published_at).reduce((acc, a) => (newerThan(a, acc) ? a : acc), null);
    const next = best ? { id: best.id, published_at: best.published_at } : null;
    if ((next?.id || null) !== (state.active?.id || null)) { state.active = next; emit(); }
}
export function useActiveBreakingId() {
    const [id, setId] = useState(state.active?.id || null);
    useEffect(() => {
        const fn = (a) => setId(a?.id || null);
        state.listeners.add(fn);
        return () => state.listeners.delete(fn);
    }, []);
    return id;
}
